import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const AdminGroupLabel = styled.span`
  color: ${color("filter")};
`;
